import React from 'react';
import PropTypes from 'prop-types';
import { BarsContainer } from './styles';

export function Bars({ className }) {
  return (
    <BarsContainer
      className={className}
      role="status"
      aria-label="Carregando análise"
    >
      <span />
      <span />
      <span />
      <span />
      <span />
    </BarsContainer>
  );
}

Bars.propTypes = {
  className: PropTypes.string,
};

Bars.defaultProps = {
  className: undefined,
};

export default Bars;
